import { render, staticRenderFns } from "./EnacAtplDashboardCompetenciesRadar.vue?vue&type=template&id=3fca35f3"
import script from "./EnacAtplDashboardCompetenciesRadar.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardCompetenciesRadar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports